import { Box, Paper, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

export default function SetupHeaderCard({ icon, title, subtitle, action }) {
  return (
    <Paper
      variant="outlined"
      sx={(theme) => ({
        p: { xs: 2, sm: 2.75 },
        borderRadius: 3,
        flexShrink: 0,
        borderColor: alpha(theme.palette.primary.main, 0.2),
        bgcolor: 'background.paper',
        boxShadow: `0 16px 40px ${alpha(theme.palette.primary.main, 0.1)}`,
      })}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'flex-start', md: 'center' }}
        justifyContent="space-between"
        spacing={2}
      >
        <Stack direction="row" spacing={1.75} alignItems="center">
          <Box
            sx={{
              display: 'grid',
              placeItems: 'center',
              width: 48,
              height: 48,
              flexShrink: 0,
              borderRadius: 2.25,
              color: 'primary.main',
              bgcolor: 'background.paper',
              boxShadow: '0 8px 22px rgba(83, 74, 183, 0.16)',
            }}
          >
            {icon}
          </Box>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, letterSpacing: '-0.02em' }}>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {subtitle}
            </Typography>
          </Box>
        </Stack>
        {action}
      </Stack>
    </Paper>
  );
}
